import SeoHead from "@/components/public/SeoHead";
import Breadcrumb from "@/components/public/Breadcrumb";

export default function MentionsLegalesPage() {
  return (
    <div data-testid="mentions-legales-page">
      <SeoHead title="Mentions légales" description="Mentions légales du site nettoyage-expert.ch. Informations sur l'éditeur, l'hébergeur et la propriété intellectuelle." path="/mentions-legales" noindex={true} />
      <Breadcrumb items={[{ name: "Accueil", url: "/" }, { name: "Mentions légales" }]} />
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <h1 className="text-3xl sm:text-4xl font-semibold text-[#062133] tracking-tight mb-8" data-testid="legal-h1">Mentions légales</h1>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Éditeur du site</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Le site <strong>www.nettoyage-expert.ch</strong> est édité par :
          </p>
          <div className="bg-[#F4F6F8] rounded-lg p-6 my-4 text-sm text-[#062133]/80 leading-relaxed space-y-1">
            <p><strong>HOMELY SOLUTIONS Sàrl</strong></p>
            <p>Société à responsabilité limitée de droit suisse</p>
            <p>Rue Jean-André-Venel 4, 1400 Yverdon-les-Bains, Suisse</p>
            <p>IDE : CHE-418.697.448</p>
            <p>N° TVA : CHE-418.697.448 TVA</p>
            <p>Registre du commerce du Canton de Vaud — CH-550-1236647-5</p>
            <p>Capital social : CHF 20'000</p>
            <p>Téléphone : <a href="tel:+41245391033" className="text-[#336DBF]">+41 24 539 10 33</a></p>
            <p>Email : <a href="mailto:info@nettoyage-expert.ch" className="text-[#336DBF]">info@nettoyage-expert.ch</a></p>
          </div>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Directrice de la publication</h2>
          <p className="text-[#062133]/70 leading-relaxed">Mary-France Henry, associée-gérante de HOMELY SOLUTIONS Sàrl.</p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Hébergeur</h2>
          <div className="bg-[#F4F6F8] rounded-lg p-6 my-4 text-sm text-[#062133]/80 leading-relaxed space-y-1">
            <p><strong>Infomaniak Network SA</strong></p>
            <p>Rue Eugène-Marziano 25, 1227 Genève, Suisse</p>
            <p>Téléphone : +41 22 820 35 44</p>
            <p>Site web : <a href="https://www.infomaniak.com" target="_blank" rel="noopener noreferrer" className="text-[#336DBF]">www.infomaniak.com</a></p>
          </div>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Propriété intellectuelle</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            L'ensemble du contenu du site www.nettoyage-expert.ch (textes, images, graphismes, logo, icônes, sons, logiciels, etc.) est la propriété exclusive de HOMELY SOLUTIONS Sàrl ou de ses partenaires. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de HOMELY SOLUTIONS Sàrl.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Responsabilité</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            HOMELY SOLUTIONS Sàrl s'efforce de fournir sur le site www.nettoyage-expert.ch des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations. Les informations présentes sur le site sont données à titre indicatif et sont susceptibles d'évoluer. Les prix indiqués ne sont pas contractuels et peuvent varier selon les prestations demandées.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Liens hypertextes</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Le site www.nettoyage-expert.ch peut contenir des liens hypertextes vers d'autres sites. HOMELY SOLUTIONS Sàrl ne dispose d'aucun contrôle sur le contenu de ces sites tiers et décline toute responsabilité quant à leur contenu.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Droit applicable</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Le présent site et les mentions légales qui y figurent sont soumis au droit suisse. En cas de litige, les tribunaux du canton de Vaud sont compétents.
          </p>

          <p className="text-[#062133]/40 text-xs mt-12">Dernière mise à jour : septembre 2026</p>
          <p className="text-[#062133]/40 text-xs mt-2">
            Infrastructure digitale et acquisition client : <a href="https://darven.ch" target="_blank" rel="noopener" className="hover:underline">Darven</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
